import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React from 'react';
import * as Yup from 'yup';
import {Button} from '~/components/Button';
import {Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';

interface ICreateTokenValues {
    name: string;
}

interface ICreateTokenFormProps {
    onSubmit?: (values: ICreateTokenValues, formikActions: FormikActions<ICreateTokenValues>, close: IModalComponentClose) => void;
}

const schema = Yup.object().shape({
    name: Yup.string().required(),
});

export const CreateTokenForm: IModalComponent<ICreateTokenFormProps> = props => (
    <Formik
        initialValues={{name: ''}}
        validationSchema={schema}
        onSubmit={(values, actions) => props.onSubmit(values, actions, props.close)}
    >
        {({status, isSubmitting}) => (
            <Form>
                <FormTitle>Generate API token</FormTitle>
                {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
                <FormRow>
                    <FormColumn>
                        <Field
                            name="name"
                            label="Name"
                            options={{placeholder: 'e.g. ci', disabled: isSubmitting}}
                            component={InputField}
                        />
                    </FormColumn>
                </FormRow>
                <FormControls>
                    <Button disabled={isSubmitting} onClick={props.close}>Cancel</Button>
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        intent={Intent.PRIMARY}
                        rightIcon={isSubmitting && <i className="fa fa-spinner fa-spin"/>}
                    >
                        Generate
                    </Button>
                </FormControls>
            </Form>
        )}
    </Formik>
);
